export default __webpack_public_path__ + "static/media/dvd.a1b3fde2.svg";